<template>
<div class="animated fadeIn">
  <b-row class="justify-content-center">
    <b-col md="12">
      <b-card>
        <b-card-body>
          <h3 class="text-center mb-4">Application for Short Stay in Soami Bagh</h3>
          <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
            <b-form-group label="Bhandara/Satsang" label-cols-sm="4" label-cols-lg="3">
              <event-type-select v-model="$v.form.eventType.$model"></event-type-select>
              <b-form-invalid-feedback id="liveFeedbackIdEventType" :state="chkState('eventType')">
                Please select Bhandara/Satsang
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Soami Bagh Id Card No" label-for="id-card-no" label-cols-sm="4" label-cols-lg="3">
              <b-form-input id="id-card-no" type="text" aria-describedby="liveFeedbackIdCardNo" :state="chkState('idCardNo')" v-model.lazy.trim="$v.form.idCardNo.$model" placeholder="Soami Bagh Id Card No" autofocus :disabled="noIdCard" @change="changeIdCardNo"/>
              <b-form-invalid-feedback id="liveFeedbackIdCardNo">
                This is a required field
              </b-form-invalid-feedback>
              <b-form-checkbox class="mt-2" @change="noIdCard = !noIdCard">I don't have Soamibagh Issued I-Card</b-form-checkbox>
            </b-form-group>

            <b-form-group v-if="noIdCard" label="Why no Id Card?" label-for="id-card-reason" label-cols-sm="4" label-cols-lg="3">
              <v-select :options="reasonOptions"
                placeholder="Please select why the satsangi doesn't have the Id Card"
                v-model="$v.form.idCardReason.$model">
              </v-select>
            </b-form-group>

            <b-form-group v-if="noIdCard" label="Name Of Applicant" label-for="applicant-name" label-cols-sm="4" label-cols-lg="3">
              <b-form-input id="applicant-name" type="text" aria-describedby="liveFeedbackApplicantName" :state="chkState('applicantName')" v-model.lazy.trim="$v.form.applicantName.$model" placeholder="Name Of Applicant" autofocus />
              <b-form-invalid-feedback id="liveFeedbackApplicantName">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group v-if="noIdCard" label="Any I-Card No" label-for="other-card-number" label-cols-sm="4" label-cols-lg="3">
              <b-form-input id="other-card-number" type="text" aria-describedby="liveFeedbackOtherCardNo" :state="chkState('otherCardNo')" v-model.lazy.trim="$v.form.otherCardNo.$model" autofocus placeholder="Like aadhar etc." />
              <b-form-invalid-feedback id="liveFeedbackOtherCardNo">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group v-if="noIdCard" label="Updeshi or Non Updeshi" label-cols-sm="4" label-cols-lg="3">
              <b-form-radio-group v-model="$v.form.isUpdeshi.$model" class="pt-2" :state="chkState('isUpdeshi')">
                <b-form-radio value="1">Updeshi</b-form-radio>
                <b-form-radio value="0">Non Updeshi</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group v-if="noIdCard" label="Address" label-for="address" label-cols-sm="4" label-cols-lg="3">
              <b-form-textarea id="address" aria-describedby="liveFeedbackAddress" :state="chkState('address')" v-model.lazy.trim="$v.form.address.$model" placeholder="Address" rows="3" max-rows="6">
              </b-form-textarea>
              <b-form-invalid-feedback id="liveFeedbackAddress">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group v-if="noIdCard" label="Name of Referral (Correspondent)" label-for="referralName" label-cols-sm="4" label-cols-lg="3">
              <b-form-input id="referralName" type="text" aria-describedby="liveFeedbackReferralName" :state="chkState('referralName')" v-model.lazy.trim="$v.form.referralName.$model" autofocus placeholder="Name of Referral" />
              <b-form-invalid-feedback id="liveFeedbackReferralName">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Number of members visiting" label-for="numberMembers" label-cols-sm="4" label-cols-lg="3">
              <b-input-group>
                <b-input-group-prepend>
                  <b-button variant="outline-info" @click="removeMember">Remove Member</b-button>
                </b-input-group-prepend>
                <b-form-input v-model="numberOfMembers" disabled></b-form-input>
                <b-input-group-append>
                  <b-button variant="success" @click="addMember">Add Member</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <member-list ref="memberList"></member-list>
       
            <b-form-group label="Date of Arrival" label-for="arrivalDate" label-cols-sm="4" label-cols-lg="3">
              <b-form-input type="text" :value="$v.form.arrivalDate.$model" disabled />          
                
            </b-form-group>
         
                            <b-form-group label="Arrival Time" label-for="fromTime"  label-cols-sm="4" label-cols-lg="3">
                                <b-input-group class="mb-3">
                                    <b-form-input id="fromTime-input" v-model="$v.form.fromTime.$model" type="text"
                                        placeholder="HH:mm"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-timepicker id="fromTime" name="fromTime" v-model="$v.form.fromTime.$model"
                                            button-only right locale="en" :state="chkState('fromTime')"
                                            aria-describedby="liveFeedbackFromTime" now-button reset-button
                                            aria-controls="fromTime-input"></b-form-timepicker>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-form-invalid-feedback id="liveFeedbackFromTime">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                         
            <b-form-group label="Date of Departure" label-for="departureDate" label-cols-sm="4" label-cols-lg="3">
              <b-form-input type="text" :value="$v.form.departureDate.$model" disabled />
            </b-form-group>
           
                            <b-form-group label="Departure Time" label-for="toTime"  label-cols-sm="4" label-cols-lg="3">
                                <b-input-group class="mb-3">
                                    <b-form-input id="toTime-input" v-model="$v.form.toTime.$model" type="text"
                                        placeholder="HH:mm"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-timepicker id="toTime" name="toTime" v-model="$v.form.toTime.$model"
                                            button-only right locale="en" :state="chkState('toTime')"
                                            aria-describedby="liveFeedbackToTime" now-button reset-button
                                            aria-controls="toTime-input"></b-form-timepicker>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-form-invalid-feedback id="liveFeedbackToTime">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                     
            <b-form-group label="Contact Number" label-for="phone" label-cols-sm="4" label-cols-lg="3">
              <b-form-input id="phone" type="text" aria-describedby="liveFeedbackContactNumber" :state="chkState('phone')" v-model.lazy.trim="$v.form.phone.$model" placeholder="Contact Number" />
              <b-form-invalid-feedback id="liveFeedbackContactNumber">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Email" label-for="email" label-cols-sm="4" label-cols-lg="3">
              <b-form-input id="email" type="text" aria-describedby="liveFeedbackEmail" :state="chkState('email')" v-model.lazy.trim="$v.form.email.$model" placeholder="Email" />
              <b-form-invalid-feedback id="liveFeedbackEmail">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Any member(s) medical constraint" label-for="medicalConstraint" label-cols-sm="4" label-cols-lg="3">
              <b-form-input id="medicalConstraint" type="text" aria-describedby="liveFeedbackMedicalConstraint" v-model.lazy.trim="$v.form.medicalConstraint.$model" placeholder="Any member(s) medical constraint" />
            </b-form-group>

            <b-form-group label="Eating at Bhandarghar" label-for="meal" label-cols-sm="4" label-cols-lg="3">
                <v-select :options="['YES', 'NO']"
                  placeholder="Please choose If eating at Bhandarghar " aria-describedby="liveFeedbackMeal"
                  v-model="$v.form.meal.$model">
                </v-select>
                <b-form-invalid-feedback id="liveFeedbackMeal">
                This is a required field
              </b-form-invalid-feedback>
              </b-form-group>      

            <b-form-group label="Comments" label-for="comments" label-cols-sm="4" label-cols-lg="3">
              <b-form-textarea
                id="comments"
                v-model="$v.form.comments.$model"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>

            <b-button type="submit" variant="primary">
              Submit
            </b-button>
          </b-form>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</div>
</template>

<script>
import Vue from 'vue'
import {
  required,
  email
} from "vuelidate/lib/validators"

import EventTypeSelect from '../../components/EventTypeSelect'
import BuildingSelect from '../../components/BuildingSelect'
import MemberList from '../../components/MemberList'

const formShape = {
  eventType: null,
  idCardNo: "",
  idCardReason: null,
  applicantName: "",
  otherCardNo: "",
  isUpdeshi: null,
  referralName: "",
  address: "",
  arrivalDate: "",
  departureDate: new Date(),
  phone: "",
  email: "",
  medicalConstraint: "",
  comments: "",
  meal: null,
  fromTime: null,
  toTime: null,
}

export default {
  name: 'BookingForm',
  props: {
    arrival: Date,
    departure: Date,
    rooms: Array
  },
  components: {
    EventTypeSelect,
    BuildingSelect,
    MemberList
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    }
  },
  validations() {
    let form = !this.noIdCard ? {
      idCardNo: {
        required
      }
    } : {
      idCardNo: {},
      idCardReason: {
        required,
      },
      applicantName: {
        required
      },
      otherCardNo: {
        required
      },
      isUpdeshi: {
        required
      },
      address: {
        required
      },
      referralName: {
        required
      },
      meal: {
        required
      },
      fromTime: { required },
         
            toTime: { required },
    }

    _.merge(form, {
      eventType: {
        required
      },
      arrivalDate: {
        required
      },
      departureDate: {
        required
      },
      phone: {
        required
      },
      email: {
        required,
        email
      },
      medicalConstraint: {},
      meal: {
        required
      },
      fromTime: { required },
         
         toTime: { required },
      comments: {}
    })

    return {
      form
    }
  },
  data: function() {
    return {
      form: Object.assign({}, formShape),
      noIdCard: false,
      numberOfMembers: 0,
      reasonOptions: [
        {label: "New to Satsang", value: "NEW_TO_SATSANG"},
        {label: "Support to elder person", value: "SUPPORT_ELDER_PERSON"},
        {label: "Child", value: "Child"},
      ]
    };
  },
  methods: {
    changeIdCardNo(value) {
      this.$store.dispatch('customers/getCustomer', {id_card_no: value})
      .then((customer) => {
        if (customer) {
          this.numberOfMembers = 1
          this.form.email = customer.email
          this.form.phone = customer.phone
          this.$refs.memberList.setMember(customer)
        }

      })
    },
    addMember() {
      if (this.numberOfMembers < 20) {
        this.numberOfMembers++
        this.$refs.memberList.addMember()
      }
    },
    removeMember() {
      if (this.numberOfMembers > 0) {
        this.numberOfMembers--
        this.$refs.memberList.removeMember()
      }
    },
    onSubmit() {
      let returnValue = this.compareDates(this.form.arrivalDate, this.form.departureDate);
      console.log(returnValue);
      if(returnValue == false){
        this.showErrorMsg({
                message: "Departure date must be after the arrival date"
              })
        return;      
      }
      if (this.validate() && this.$refs.memberList.validate()) {
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            event_type_id: this.form.eventType.value,
            id_card_no: this.noIdCard ? null : this.form.idCardNo,
            id_card_reason: this.noIdCard ? this.form.idCardReason.value : null,
            applicant_name: this.noIdCard ? this.form.applicantName : null,
            other_card_no: this.noIdCard ? this.form.otherCardNo : null,
            is_updeshi: this.noIdCard ? this.form.isUpdeshi : null,
            address: this.noIdCard ? this.form.address : null,
            referral_name: this.noIdCard ? this.form.referralName : null,
            members: this.$refs.memberList.getMembers(),
            arrival_date: this.formatDate(this.form.arrival),
            departure_date: this.formatDate(this.form.departure),
            phone: this.form.phone,
            email: this.form.email,
            medical_constraint: this.form.medicalConstraint,
            bhandarghar_ticket: this.form.meal,
            comments: this.form.comments,
            room_ids: _.map(this.rooms, room => room.id),
            arrival_time: this.form.fromTime,
            departure_time: this.form.toTime
          }

          this.$store.dispatch('reservations/adminCreateReservation', params)
            .then(() => {
              this.showSuccessMsg()
              this.$emit('success')
            })
            .catch((error) => {
              this.showErrorMsg({
                message: error
              })
            })
        })
      }
    },
    onCancel() {
      this.$emit('cancel')
    },
    onReset() {
      this.form = Object.assign({}, formShape)
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
      this.numberOfMembers = 0
      this.$refs.memberList.onReset()
    },
    chkState(val) {
      const field = this.$v.form[val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  created() {
    this.form.arrivalDate = this.$moment(this.arrival).format('DD/MM/YYYY')
    this.form.departureDate = this.$moment(this.departure).format('DD/MM/YYYY')
  }
}
</script>
